/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsinformatik13Inputs */

const en__field_enum_mzsinformatik13 = /** @type {(inputs: _Field_Enum_Mzsinformatik13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`computer science and math`)
};

const de__field_enum_mzsinformatik13 = /** @type {(inputs: _Field_Enum_Mzsinformatik13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik und Mathematik`)
};

/**
* | output |
* | --- |
* | "computer science and math" |
*
* @param {_Field_Enum_Mzsinformatik13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsinformatik13 = /** @type {((inputs?: _Field_Enum_Mzsinformatik13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsinformatik13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsinformatik13(inputs)
	return de__field_enum_mzsinformatik13(inputs)
});
export { _field_enum_mzsinformatik13 as "_field_enum_MZSINFORMATIK" }